import React from 'react';
import { Modal, View, Text, TouchableOpacity, useWindowDimensions } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import { fontFamily } from '../../helpers/fontFamily';

const RulesConfirmModal = ({
  visible,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  showUndoneWarning = false,
  onConfirm,
  onCancel,
}) => {
  const { width: screenWidth } = useWindowDimensions();
  const modalWidth = Math.min(screenWidth * 0.9, 500);
  const horizontalPadding = screenWidth <= 768 ? 16 : 28;

  return (
    <Modal
      visible={visible}
      transparent
      animationType="fade"
      onRequestClose={onCancel}
    >
      <View style={{
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0,0,0,0.5)',
      }}>
        <LinearGradient
          colors={['#FFB538', '#CF7C08']}
          start={{ x: 0.5, y: 0 }}
          end={{ x: 0.5, y: 1 }}
          style={{
            paddingVertical: 30,
            paddingHorizontal: horizontalPadding,
            borderRadius: 15,
            alignItems: 'center',
            position: 'relative',
            width: modalWidth,
          }}
        >
          {/* X close */}
          <TouchableOpacity
            onPress={onCancel}
            style={{ position: 'absolute', top: 10, right: 10, zIndex: 10, padding: 5 }}
          >
            <Text style={{ fontSize: 24, color: '#000000', fontWeight: 'bold' }}>×</Text>
          </TouchableOpacity>

          {/* Title */}
          <Text style={{
            fontSize: 24,
            marginBottom: 10,
            fontFamily: fontFamily.font300,
            textAlign: 'center',
            color: '#000000',
          }}>
            {title}
          </Text>

          {/* Message */}
          <Text style={{
            fontSize: 18,
            marginBottom: showUndoneWarning ? 5 : 20,
            fontFamily: fontFamily.font300,
            textAlign: 'center',
            color: '#000000',
          }}>
            {message}
          </Text>

          {/* "This action cannot be undone" — shown for destructive actions */}
          {showUndoneWarning && (
            <Text style={{
              fontSize: 20,
              marginBottom: 20,
              fontFamily: fontFamily.font300,
              textAlign: 'center',
              color: '#000000',
            }}>
              This action cannot be undone.
            </Text>
          )}

          {/* Buttons */}
          <View style={{ flexDirection: 'row', justifyContent: 'space-between', gap: 15 }}>
            <TouchableOpacity
              style={{
                paddingHorizontal: 10,
                paddingVertical: 3,
                borderRadius: 15,
                minWidth: 100,
                alignItems: 'center',
                borderWidth: 1,
                borderColor: '#000000',
              }}
              onPress={onCancel}
            >
              <Text style={{ color: '#000000', fontFamily: fontFamily.font300 }}>
                {cancelText}
              </Text>
            </TouchableOpacity>

            <TouchableOpacity
              style={{
                paddingHorizontal: 10,
                paddingVertical: 3,
                borderRadius: 15,
                minWidth: 100,
                alignItems: 'center',
                borderWidth: 1,
                borderColor: '#000000',
              }}
              onPress={onConfirm}
            >
              <Text style={{ color: '#000000', fontFamily: fontFamily.font300 }}>
                {confirmText}
              </Text>
            </TouchableOpacity>
          </View>
        </LinearGradient>
      </View>
    </Modal>
  );
};

export default RulesConfirmModal;
